import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/order',
    name: 'orderViews',
    component: () => import('@/views/saveOrder/OrderViews.vue')
  },
  {
    path: '/orders',
    name: 'orderMobil',
    component: () => import('@/views/saveOrder/OrderMobil.vue')
  },
  {
    path: '/product',
    name: 'ProductSearchViews',
    component: () => import('@/views/saveOrder/ProductSearchViews.vue')
  },
  {
    path: '/produce',
    name: 'ProduceViews',
    component: () => import('@/views/saveOrder/ProduceOrder.vue')
  },
  {
    path: '/',
    name: 'AuthViews',
    component: () => import('@/views/saveOrder/AuthViews.vue')
  },
  {
    path: '/callback',
    name: 'CallbackViews',
    component: () => import('@/views/saveOrder/CallbackViews.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
